/**
* @Description 文件功能说明：上传预览弹窗
* @Author 张彬
* @Time 2021/3/13 11:33
**/

/* HTML */
<template>
    <div v-if="dialogTreeItem.dialogFormVisible">
        <el-dialog :title="dialogTreeItem.title"
                   :visible.sync="dialogTreeItem.dialogFormVisible"
                   :close-on-click-modal="false"
                   custom-class="form-dialog"
                   v-dialogDrag
                   :modal-append-to-body="false"
                   class="dialog_title"
                   @close="handleDialogClose"
        >
            <el-form label-width="150px" class="condition-form-item" :model="rowForm" ref="rowForm" :rules="rules">
                <el-form-item label="基站编号：">
                    {{setBs.bsId + " (" + setBs.bsSid + ")"}}
                </el-form-item>
                <el-form-item label="安装序号：" prop="bsSerial">
                    <el-input v-model="rowForm.bsSerial" clearable placeholder="请输入格式：数字 - 数字"/>
                </el-form-item>
                <el-form-item label="安装高度：" prop="pointZ">
                    <el-input v-model="rowForm.pointZ" clearable>
                        <template slot="append">米</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="基站组：" prop="bsGroupIds">
                    <el-select v-model="rowForm.bsGroupIds" multiple filterable placeholder="请选择基站组" clearable>
                        <el-option v-for="(item,key) in bsGroups" :key="item.groupId" :label="item.groupName" :value="item.groupId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="X坐标：" prop="pointX">
                    <el-input v-model="rowForm.pointX" clearable>
                        <template slot="append">米</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="Y坐标：" prop="pointY">
                    <el-input v-model="rowForm.pointY" clearable>
                        <template slot="append">米</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="是否重置：" prop="reset">
                    <el-radio-group v-model="rowForm.reset">
                        <el-radio class="radio" :label="true">是</el-radio>
                        <el-radio class="radio" :label="false">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item class="row-items-1 btn-form-item-c" >
                    <el-button type="primary" @click.native="submit" size="mini">{{dialogTreeItem.submitButton}}</el-button>
                </el-form-item>
            </el-form>

        </el-dialog>
    </div>

</template>

/* JS */
<script>
import ApiOam from '@/request/api-oam'
import {checkFormat, validFormat} from "@/global/global-valid";
export default {

    /**
     * @Des 组件名
     * @Auth Zhangbin
     * @Date 17:22 2021/4/30
     */
    name: 'UwbBSRangeSetDialog',

    /**
     * @Des 组件引用
     * @Auth Zhangbin
     * @Date 17:22 2021/4/30
     */
    components: {
    },

    /**
     * @Des 数据接收类型
     * @Auth Zhangbin
     * @Date 17:22 2021/4/30
     */
    props: {
        setBs: {
            type: Object,
            default: function (){
                return {}
            }
        },
        rangeGroupId: 0,
    },

    /**
     * @Des 数据定义
     * @Auth Zhangbin
     * @Date 17:23 2021/4/30
     */
    data() {
        return{

            /**
             * @Des 弹出层属性
             * @Auth Zhangbin
             * @Date 17:23 2021/4/30
             */
            dialogTreeItem: {
                title: '',
                dialogFormVisible: false,
                submitButton: '',
            },
            rowForm: {
                bsGroupIds: [],
                pointX: 0,
                pointY: 0,
                pointZ: 3.5,
                bsSerial: '',
                reset: true
            },
            bsGroups: [],
            rules: {
                bsSerial: [
                    { required: false, message: '安装序号不能为空', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            this.rowForm.bsSerial = value != null ? value.trim() : '';
                            if(this.rowForm.bsSerial.length == 0){
                                new callback(new Error("安装序号不能为空"));
                            }else{
                                let split = this.rowForm.bsSerial.split("-");
                                if(split.length != 2 || !checkFormat(split[0], validFormat.num_gte_0) || !checkFormat(split[1], validFormat.num_gte_0)){
                                    new callback(new Error("请输入格式：数字 - 数字"));
                                }else{
                                    callback();
                                }
                            }

                        },
                        trigger: "blur"
                    }
                ],
                bsGroupIds: [
                    { required: false, message: '基站组不能为空', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (this.rowForm.bsGroupIds.length == 0) {
                                new callback(new Error("基站组不能为空"));
                            } else {
                                callback()
                            }
                        },
                        trigger: "blur"
                    }
                ],
                pointX: [
                    { required: false, message: 'X坐标不能为空', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {

                            if ((value == null || !checkFormat(value, validFormat.float))) {
                                new callback(new Error("输入无效"));
                            } else {
                                callback()
                            }
                        },
                        trigger: "blur"
                    }
                ],
                pointY: [
                    { required: false, message: 'Y坐标不能为空', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if ((value == null || !checkFormat(value, validFormat.float))) {
                                new callback(new Error("输入无效"));
                            } else {
                                callback()
                            }
                        },
                        trigger: "blur"
                    }
                ],
                pointZ: [
                    { required: false, message: '安装高度不能为空', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if ((value == null || !checkFormat(value, validFormat.float))) {
                                new callback(new Error("输入无效"));
                            } else {
                                callback()
                            }
                        },
                        trigger: "blur"
                    }
                ],
            }
        }
    },
    /**
     * @Des 方法定义
     * @Auth Zhangbin
     * @Date 17:24 2021/4/30
     */
    methods: {
        /**
         * @Des 打开弹窗
         * @Auth Zhangbin
         * @Date 17:24 2021/4/30
         */
        openDialog(title, button, data){
            this.dialogTreeItem.title = title;
            this.dialogTreeItem.dialogFormVisible = true;
            this.dialogTreeItem.submitButton = button;
            this.$nextTick(() => {
                if(data.bsGroups){
                    this.bsGroups = data.bsGroups;
                }
                if(this.setBs){
                    this.rowForm.bsSerial = this.setBs.bsSerial && this.setBs.bsSerial != '' ? this.setBs.bsSerial: "1-1";
                    this.rowForm.pointX = this.setBs.pointX == null ? 0: this.setBs.pointX;
                    this.rowForm.pointY = this.setBs.pointY == null ? 0: this.setBs.pointY;
                    this.rowForm.pointZ = this.setBs.pointZ == null ? 3.5: this.setBs.pointZ;
                    
                    if (this.setBs.bsGroupIds && this.setBs.bsGroupIds.length > 0) {
                    	this.rowForm.bsGroupIds = this.setBs.bsGroupIds;
                    } else {
                    	let keys = Object.keys(this.bsGroups);
                    	if (keys > 0) {
                    		this.rowForm.bsGroupIds = (this.bsGroups && this.bsGroups[keys[0]] && this.bsGroups[keys[0]].groupId) > 0 ? [this.bsGroups[keys[0]].groupId] : [];
                    	} else {
                    		this.rowForm.bsGroupIds = [];
                    	}
                    }
                }
            })
        },

        /**
         * @Des 关闭弹窗
         * @Auth Zhangbin
         * @Date 17:24 2021/4/30
         */
        handleDialogClose(){
            this.dialogTreeItem.dialogFormVisible = false;
            this.$emit("research");
        },

        /**
         * @Des 数据提交
         * @Auth Zhangbin
         * @Date 17:49 2021/4/30
         */
        submit(){
            if(this.operationLock) return;
            this.$refs.rowForm.validate(valid => {
                if(!valid) return false;
                this.operationLock = true;
                this.$request.postJsonRequest(ApiOam.Update_Uwb_Bs_Point_Uri, {
                    sid: this.setBs.bsSid,
                    pointX: this.rowForm.pointX,
                    pointY: this.rowForm.pointY,
                    pointZ: this.rowForm.pointZ,
                    bsSerial: this.rowForm.bsSerial,
                    groupIds: this.rowForm.bsGroupIds,
                    rangeGroupId: this.rangeGroupId,
                    reset: this.rowForm.reset
                }).then(result => {
                    if(result.code == 0){
                        this.$message({
                            message: '设置成功',
                            type: 'success',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        this.handleDialogClose();
                        this.$emit("research");
                    }else{
                        this.$message({
                            message: result.msg,
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }
                    this.operationLock = false;
                }).catch(error => {
                	this.operationLock = false;
                	console.error('设置测距基站异常', ApiOam.Update_Uwb_Bs_Point_Uri, error);
                });
            });
        },
    },

}
</script>

/* CSS */
<style lang="scss" scoped>
	/deep/ .el-dialog {
		width: 800px;
	}
	/deep/ .form-dialog .el-select {
		width: auto;
	}
	/deep/ .form-dialog .el-form,
	/deep/ .form-dialog .el-form-item {
		margin-bottom: 0px;
	}
    /deep/ .el-input__inner{
        width: 555px!important;
    }
    /deep/ .form-dialog .el-form-item{
        margin-bottom: 20px;
    }

</style>



// WEBPACK FOOTER //
// src/components_pages/Device/UwbBSRangeSetDialog.vue